import {Component, inject, OnInit} from '@angular/core';
import {LoginComponent} from '../login/login.component';
import {RedirectService} from '../../../../core/services/redirect.service';

@Component({
  selector: 'app-login-page',
  imports: [
    LoginComponent
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent implements OnInit {
  redirectService = inject(RedirectService);

  ngOnInit() {
    if (!this.redirectService.isAvailable()) {
      this.redirectService.set({url: "/profile"})
    }
  }
}
